import styled from '@emotion/styled';

import { TabletWidth } from '../../../global.style';
import { getColor } from '../../common/UICommon';
import { MainButtonHeight } from '../../styledComponent/Buttons.style';

const MobileButtonWrapperHeight = MainButtonHeight + 16 * 2; // height + padding offset
const DesktopPaddingVertical = 100;

export const InfoV2Screen = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  padding: ${DesktopPaddingVertical}px 90px;
  background-color: ${getColor('WHITE')};

  @media (max-width: ${TabletWidth}px) {
    padding: 42px 24px 16px;
  }
`;

export const InfoV2ScreenDesktop = styled.div`
  width: 100%;
  height: 100%;

  display: flex;
  align-items: center;
  justify-content: left;

  @media (max-width: ${TabletWidth}px) {
    display: none;
  }
`;

export const InfoV2ScreenDesktopLeft = styled.div`
  width: 50%;
  height: 100%;

  display: flex;
  align-items: center;
  justify-content: left;
`;

export const InfoV2ScreenDesktopRight = styled.div<{ imageFullSize?: boolean }>`
  width: 50%;
  height: ${({ imageFullSize }) => (imageFullSize ? `calc(100% + ${2 * DesktopPaddingVertical}px)` : '100%')};
  align-content: center;
`;

export const InfoV2ScreenContentWrapper = styled.div<{ withGuidesCarousel?: boolean }>`
  max-width: 460px;
  text-align: left;

  @media (max-width: ${TabletWidth}px) {
    max-width: 140%;
    text-align: center;
    height: calc(100% - ${MobileButtonWrapperHeight}px);
    overflow: ${({ withGuidesCarousel }) => (withGuidesCarousel ? 'auto' : 'hidden')};
  }
`;

export const InfoV2ScreenSection = styled.h3`
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
  color: ${getColor('GRAY_80')};
  margin-bottom: 42px;

  @media (max-width: ${TabletWidth}px) {
    text-align: center;
    margin-bottom: 12px;
  }
`;

export const InfoV2ScreenTitle = styled.h3`
  font-family: Lora;
  font-size: 42px;
  font-weight: 600;
  line-height: 48px;
  color: ${getColor('GRAY_95')};
  margin-bottom: 20px;

  @media (max-width: ${TabletWidth}px) {
    font-size: 24px;
    line-height: 30px;
    margin-bottom: 12px;
  }
`;

export const InfoV2ScreenDescription = styled.p<{ withGuidesCarousel?: boolean }>`
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: ${getColor('GRAY_95')};
  margin-bottom: 52px;
  max-width: 330px;
  text-align: left;

  @media (max-width: ${TabletWidth}px) {
    color: ${getColor('GRAY_60')};
    margin-bottom: 0px;
    text-align: center;
    max-width: 100%;
    margin-bottom: 24px;
  }

  @media (max-height: 640px) {
    display: ${({ withGuidesCarousel }) => (withGuidesCarousel ? 'none' : 'block')};
  }
`;

export const InfoV2ScreenButtonWrapper = styled.div`
  width: 205px;
`;

export const InfoV2ScreenImgDesktop = styled.div<{ img: string; imageFullSize?: boolean }>`
  background-image: url(${({ img }) => img});
  height: 100%;
  width: 100%;
  background-repeat: no-repeat;
  background-position: right;
  background-size: contain;
`;

export const InfoV2ScreenMobile = styled.div`
  width: 100%;
  height: 100%;

  @media (min-width: ${TabletWidth + 1}px) {
    display: none;
  }
`;

export const InfoV2ScreenMobileImgWrapper = styled.div`
  margin-bottom: 36px;
  overflow: hidden;
`;

export const InfoV2ScreenImgMobile = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

export const InfoV2ScreenMobileButtonWrapper = styled.div`
  height: ${MobileButtonWrapperHeight}px;
  display: flex;
  align-items: flex-end;

  @media (max-width: ${TabletWidth}px) {
    padding: 16px 0;
  }
`;
